module.exports = __webpack_public_path__ + "img/mouth_male_average_mask.8b939acc.png";